import sanitizeHtml from 'sanitize-html';

export const stripScriptTags = (htmlContent: string) => {
  const decodedHTML = htmlContent
    .replace(/&lt;script&gt;/gi, '<script>')
    .replace(/&lt;\/script&gt;/gi, '</script>')
    .replace(/&lt;script(.*?)&gt;/gi, '<script$1>');

  const strippedHTML = decodedHTML.replace(/<script.*?>.*?<\/script>/gi, '');

  return strippedHTML;
};

const decodeSpecialEntities = (input: string) =>
  input
    .replace(/\&amp\;/g, '&')
    .replace(/\&lt\;/g, '<')
    .replace(/\&gt\;/g, '>')
    .replace(/\&quot\;/g, '"');

export const sanitiseInput = (input: string) => {
  const sanitised = sanitizeHtml(input, {
    disallowedTagsMode: 'discard',
  });

  return stripScriptTags(decodeSpecialEntities(sanitised));
};
